export enum IssueResolutionEnum {
  NOT_ACCEPTED = 'not-accepted',
  RESOLVED = 'resolved',
  UNRESOLVED = 'unresolved',
}

export type IssueResolutionType = `${IssueResolutionEnum}`;
